import { useGuild } from 'app/frontend/base/config/context/guild'
import Subheader from 'app/frontend/base/components/Subheader'
import { useTeamMenuItems } from '../../TeamDashboard/components/TeamSubheader'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'
import CustomDomainDashboardHeader from './CustomDomainDashboardHeader'

const CustomTeamHeader = () => {
  const { guild, currentTeam: team } = useGuild()
  const { customDomain } = useCustomDomain()

  const { eventsMenuItems, lootMenuItems } = useTeamMenuItems()

  const uriLinkFragment = `${guild?.realm?.region.toLowerCase()}/${
    guild?.realm?.slug
  }/${guild?.slug}`

  const contentOptions: Record<string, string> = {
    guildName: guild?.name ?? '',
    teamDescription: team?.description ?? '',
    teamName: team?.name ?? '',
    none: '',
  }

  const title =
    contentOptions[customDomain?.headerConfig?.titleType ?? 'guildName']

  const subtitle =
    contentOptions[
      customDomain?.headerConfig?.subtitleType ?? 'teamDescription'
    ]

  return (
    <>
      <CustomDomainDashboardHeader
        title={title}
        subtitle={subtitle}
        uriLinkFragment={uriLinkFragment}
      />

      {window.location.pathname.startsWith('/loot') ? (
        <Subheader menuItems={lootMenuItems} fullWidth={true} />
      ) : window.location.pathname.startsWith('/events') ||
        window.location.pathname.startsWith('/plans') ? (
        <Subheader menuItems={eventsMenuItems} fullWidth={true} />
      ) : null}
    </>
  )
}

export default CustomTeamHeader
